import React from 'react';
import { Link } from 'react-router-dom';
import { getlanguagelist } from "../../helpers/changelanguage";
import './footer.css';


const Footer = (props) => {
  let languagelist = props.language;
  return(
  <footer className="text-center footer-sec">
      <div className=" container">
      <p>{languagelist.copyright}©BaalDahab, {new Date().getFullYear()}</p>
      <p>{languagelist.version} 1.0</p>
      <ul>
          <li><a href="/terms_n_condition" target="_blank">{languagelist.footer_1}</a></li>
          <li><a href="/privacy_policy" target="_blank">{languagelist.footer_2}</a></li>
          <li><a href="/payment_policy" target="_blank">{languagelist.footer_3}</a></li>
          <li><a href="/refund_policy" target="_blank">{languagelist.footer_4}</a></li>
          <li><a href="/subscription_cancellation_policy" target="_blank">{languagelist.footer_5}</a></li>
          <li><a href="/delivery_policy" target="_blank">{languagelist.footer_6}</a></li>
      </ul>
      </div>
      <div className="clearfix"></div>
  </footer>
);
}
export default Footer;